import { ThemaFromThemaRouter } from '../../../dtos';
import { getProduktManager, getProduktManagerAssistenz } from '../../../utils/themaProdukte';
import { content } from './TerminAnsprechpartnerCard.content';

export const printPM = (thema: Parameters<typeof getProduktManager>[0]): string =>
  getProduktManager(thema).join(', ') || content.noInfoAvailable;

export const printFachkraft = (thema: Parameters<typeof getProduktManagerAssistenz>[0]): string =>
  getProduktManagerAssistenz(thema).join(', ') || content.noInfoAvailable;

export const printTeamPlanning = (thema: Pick<ThemaFromThemaRouter, 'planungsinformation'>): string =>
  thema.planungsinformation?.verantwortlicherTeamPlanning ?? content.noInfoAvailable;
